import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
        <Provider store={store}>
                <Router>
                    <App />
                </Router>
        </Provider>

    , document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js